import Const from './const';
import Data from './data';
import dayjs from 'dayjs';
import Api from './api/index';
import { message, Modal } from 'ant-design-vue';

import dIsBetween from 'dayjs/plugin/isBetween';
dayjs.extend(dIsBetween);

import { isObject } from 'lodash';

const VUE_APP_DEVICE_TYPE = (process.env['VUE_APP_DEVICE_TYPE'] || 'PLUG,PILE,TANK,CABINET').split(',');

const Util = {
	// 功能开关
	flag(key) {
		switch (key) {
			case 'gaode':
				return true;
		}
		return true;
	},
	/** 判断当前登录用户是否有某项权限
	 * @param {String,String} keys 权限的关键字
	 */
	auth(...arr) {
		if (!arr.length) {
			return true;
		}
		const rolesMap = Data.getAuthority() || {};
		return arr.some((key) => {
			return rolesMap[key];
		});
	},
	device(...arr) {
		if (!arr.length) {
			return true;
		}
		return arr.some((key) => {
			return VUE_APP_DEVICE_TYPE.includes(key);
		});
	},

	/** 判断当前服务费展示版本是否为该版本
	 * @param {Number, Boolean} flag true/1: 新版本 | false/0: 旧版本
	 */
	isSerVer(flag) {
		const currFlag = Data.getServiceVersion();
		const checkFlag = flag ? true : false;
		return checkFlag === currFlag
	},

	/** 确认弹窗
	 * @param {Object} config 弹窗配置
	 * @param {String} config.title 弹窗标题
	 * @param {String} config.content 弹窗内容
	 * @param {String} config.okText 确认按钮文字
	 * @param {String} config.cancelText 取消按钮文字
	 */
	confirm(config) {
		return new Promise((resolve, reject) => {
			Modal.confirm({
				...config,
				onOk: () => {
					resolve();
				},
				onCancel: () => {
					reject();
				},
			});
		});
	},


	/* ======== 时间处理 ========== */
	/**
	 * 将秒时间戳转换成对应格式
	 * @param {*} timestamp 秒时间戳
	 * @param {String} format 时间格式
	 */
	timeFormat(timestamp, format = 'YYYY-MM-DD HH:mm:ss') {
		if (timestamp == null) return '';
		if (timestamp.toString() === '0') return '-';
		return dayjs.unix(timestamp).format(format);
	},
	/**
	 * 将时间戳转换成那一天的起始秒时间戳
	 * @param {*} timestamp 时间戳
	 * @param {String} to 默认转为'天'的开始 year/month/week/date/day/hour/minute/second
	 * @param {Number} type 1=传入的为秒时间戳 2=传入的为毫秒时间戳
	 */
	startOfTime(timestamp, to = 'date', type = 1) {
		timestamp = Number(timestamp);
		if (!timestamp) {
			return '';
		}
		switch (type) {
			case 1:
				return dayjs.unix(timestamp).startOf(to).unix();
			case 2:
				return dayjs(timestamp).startOf(to).unix();
		}
	},
	/**
	 * 将时间戳转换成那一天的结束秒时间戳
	 * @param {*} timestamp 时间戳
	 * @param {String} to 默认转为'天'的结束 year/month/week/date/day/hour/minute/second
	 * @param {Number} type 默认 1=传入的为秒时间戳 2=传入的为毫秒时间戳
	 */
	endOfTime(timestamp, to = 'date', type = 1) {
		timestamp = Number(timestamp);
		if (!timestamp) {
			return '';
		}
		switch (type) {
			case 1:
				return dayjs.unix(timestamp).endOf(to).unix();
			case 2:
				return dayjs(timestamp).endOf(to).unix();
		}
	},
	/**
	 * 计算两个秒时间戳之间的时间差
	 * @param {timestamp} begin 开始时间戳
	 * @param {timestamp} end 结束时间戳
	 * @param {String} to 默认按'天'计算时间差 year/month/week/day/hour/minute/second
	 */
	diffOfTime(begin, end, to = 'day') {
		let begin_time = dayjs.unix(begin);
		let end_time = dayjs.unix(end);
		let diff = end_time.diff(begin_time, to);
		return diff || 0;
	},
	/**
	 * @description 计算两个日期时间差，天 小时 分 秒格式
	 * @param {*} begin 当前时间
	 * @param {*} end 预约时间
	 * @param {*} flag 是否返回对象（天，小时、分钟）
	 * @returns
	 */
	getDiffByTimestamp (begin, end, flag = false) {
		// console.log("getDiffByTimestamp  begin, end:", begin, end)
		var diff = end - begin;//时间差的秒数
		// console.log("getDiffByTimestamp  diff:", diff)
		//计算出相差天数
		var days = Math.floor(diff / (24*3600));
		// console.log("getDiffByTimestamp  days:", days)

		//计算出小时数
		var leave1 = diff % (24*3600);    //计算天数后剩余的秒数
		var hours = Math.floor(leave1 / (3600));
		// console.log("getDiffByTimestamp  hours:", hours)

		//计算相差分钟数
		var leave2 = leave1 % (3600);        //计算小时数后剩余的秒数
		var minutes = Math.ceil(leave2 / (60));
		// console.log("getDiffByTimestamp  minutes:", minutes)

		//计算相差秒数
		var leave3 = leave2 % (60);      //计算分钟数后剩余的秒数
		var seconds = Math.round(leave3);
		// var returnStr = seconds + "秒";

		var returnStr = "";
		if(minutes>0) {
			returnStr = minutes + "分" + returnStr;
		}
		if(hours>0) {
			returnStr = hours + "小时" + returnStr;
		}
		if(days>0) {
			returnStr = days + "天" + returnStr;
		}

		if (flag) {
			// 返回对象（天，小时、分钟）
			return {
				seconds,
				minutes,
				hours,
				days,
			}
		}
		return returnStr;
	},
	// 获取当前时间戳
	getCurrTimeStemp() {
		return dayjs().unix()
	},
	/** 根据起始时间与结束时间 获取按日期分割的时间数组
	 * @param {timestemp} begin_time
	 * @param {timestemp} end_time
	 * @param {string} unit d=天 w=周 m=月
	 * @returns [{begin_time, end_time}, ...]
	*/
	setTimeRange (begin_time, end_time, unit='d') {
		const begin = dayjs.unix(begin_time)
		const end = dayjs.unix(end_time)

		const diff = end.diff(begin, unit) // 获取开始时间与结束时间相差的(天/周/月)数

		const divide_time = []
		for (let i = 0; i <= diff; i++) {
			divide_time.push(begin.add(i, unit))
		}

		const divide_range = new Array(divide_time.length).fill('')
		for (let i = 0; i < divide_time.length; i++) {
			divide_range[i] = {
				begin_time: divide_time[i].unix(),
				end_time: dayjs(divide_time[i]).endOf(unit).unix()
			}
		}
		divide_range[divide_range.length -1].end_time = end.unix()

		return divide_range
	},
	/* ======== 时间处理 ========== */


	/* ======== 通用方法 ========== */
	queryMerge(url, q) {
		let qr = ''
		for (const key in q) {
			qr = (qr ? qr + '&' : qr) + key + '=' + q[key]
		}
		return qr ? url + '?' + qr : url
	},

    /** 较严谨的确认对象是否有某个值 */
	hasKey(obj, key) {
        if (obj && obj.hasOwnProperty(key)) {
            return true
        }
        return false
    },
    /** 较严谨的获取对象的某个值 */
    getKey(obj, key, def = '') {
        if (typeof obj === 'object' && obj && obj.hasOwnProperty(key)) {
            return obj[key]
        } else {
            return def
        }
    },
	/** 首字母大写 */
	upperFirstLetter(str) {
		if (!str) { return '' }

		str = str.toString()
		return str.substring(0,1).toUpperCase() + str.substring(1)
	},
	/** 深拷贝
	 * @param {Object} target
	 */
	deepCopy(target) {
		let copyed_objs = [];
		function _deepCopy(target) {
			if (typeof target === 'string') {
				return target.trim();
			}
			if (typeof target !== 'object' || !target) {
				return target;
			}
			for (let i = 0; i < copyed_objs.length; i++) {
				if (copyed_objs[i].target === target) {
					return copyed_objs[i].copyTarget;
				}
			}
			let obj = {};
			if (Array.isArray(target)) {
				obj = [];
			}
			copyed_objs.push({ target: target, copyTarget: obj });
			Object.keys(target).forEach((key) => {
				if (obj[key]) {
					return;
				}
				obj[key] = _deepCopy(target[key]);
			});
			return obj;
		}
		return _deepCopy(target);
	},
	/** 判断传入的对象是否为空
	 * @param {Object} obj
	 */
	isEmptyObj(obj) {
		if (!obj) {
			return true;
		}
		return !Object.keys(obj).length;
	},
	/**
	 * 判断两个对象是否相同
	 * @param {Object} objOne
	 * @param {Object} objTwo
	 */
	isSameObjs(objOne, objTwo) {
		var o1keys = Object.keys(objOne);
		var o2keys = Object.keys(objTwo);
		if (o2keys.length !== o1keys.length) return false;
		for (let i = 0; i <= o1keys.length - 1; i++) {
			let key = o1keys[i];
			if (!o2keys.includes(key)) return false;
			if (objOne[key] !== objTwo[key]) return false;
		}
		return true;
	},
	isBetween(val, min, max) {
		return parseFloat(min) <= parseFloat(val) && parseFloat(val) <= parseFloat(max)
	},
	/** 将文件转换为Base64字节 */
	getBase64(img, callback) {
		const reader = new FileReader();
		reader.addEventListener('load', () => callback(reader.result));
		reader.readAsDataURL(img);
	},
	/** 检测字符串中是否包含 表情图标
	 * @param {String} str 需要检测的字符串
	 */
	includeEmoji(str = '') {
		str = str.toString();
		const emojiRegex = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}]/gu;
		return emojiRegex.test(str) ? true : false;
	},
	/** 检测密码复杂度 */
	checkPwdTip: false,
	checkPassword(val) {
		if (!this.regRuleTest(val, 'password')) {
			if (!this.checkPwdTip) {
				this.checkPwdTip = true
				message.warning('请确认您的密码是否符合规则')
				setTimeout(() => { this.checkPwdTip = false }, 3000)
			}
			return 0
		}
		if (this.includeEmoji(val)) {
			if (!this.checkPwdTip) {
				this.checkPwdTip = true
				message.warning('密码中请不要包含表情符号')
				setTimeout(() => { this.checkPwdTip = false }, 3000)
			}
			return 0
		}
		return 1
	},
	/** 生成一个复杂密码 */
	getComplexPassword(len = 8) {
		const item = ['abcdefghijklmnopqrstuvwxyz', 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', '!@#$%^&*()', '0123456789']
		const itemStr = item.join('')

		let password = ''
		password += item[0][Math.floor(Math.random() * 26)]
		password += item[1][Math.floor(Math.random() * 26)]
		password += item[2][Math.floor(Math.random() * 10)]

		for (let i = 3; i <= len; i++) {
			let random = Math.floor(Math.random() * itemStr.length);
			password += itemStr[random];
		}
		console.log('getComplexPassword:', password)
		return password
	},
	/** 从详细地址拆分 省市区 */
	splitAddress(text) {
		let regRule = /^(\S+省)?(\S+市)?(\S+区)?(\S+街道)?([\s\S]*)$/g
		let arr = regRule.exec(text)
		console.log('splitAddress arr:', arr)

		if (arr && !arr.length) { return [] }

		let [orgin='', province='', city='', county='', street='', address=''] = arr

		return [province, city, county, street]
	},
	/** 复制文字内容 */
	copyText(text) {
		if (navigator.clipboard) {
			// clipboard api 复制
			navigator.clipboard.writeText(text);
		} else {
			var textarea = document.createElement('textarea');
			document.body.appendChild(textarea);
			// 隐藏此输入框
			textarea.style.position = 'fixed';
			textarea.style.clip = 'rect(0 0 0 0)';
			textarea.style.top = '10px';
			// 赋值
			textarea.value = text;
			// 选中
			textarea.select();
			// 复制
			document.execCommand('copy', true);
			// 移除输入框
			document.body.removeChild(textarea);
		}
	},
	/** 用*号隐私文字内容
	 * @param {string} word
	 */
	wordMaskFormat(word = '', type) {
		if (!word) { return ''; }
		switch (type) {
			case 'part': // 手机号等 遮中间
				let len = parseInt(word.length / 3);
				if (len >= 1) {
					return word.substring(0, len) + new Array(word.length - len - len).fill('*').join('') + word.substring(word.length - len);
				} else {
					len = 1;
					return word.substring(0, len) + new Array(len).fill('*').join('');
				}
				break;
			default: // 其他 遮全部
				word = word.toString();
				return new Array(word.length).fill('*').join('');
				break;
		}
	},
    /** 用*号隐私手机号
     * @param {String} phone
     */
    phoneMaskFormat(phone = "") {
        if (!phone) return '-'
        let reg = /(\d{3})\d{4}(\d{4})/;
        return phone.replace(reg, "$1****$2")
    },

    /** 数值转换 每三位加逗号(',')分隔
	 * @param {Number} num
	 */
	countFormat(num = '') {
		let str = num.toString();
		let reg = str.indexOf('.') > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
		return str.replace(reg, '$1,');
	},
	/** 返回拼接后的 导出链接
	 * @param {String} apiName
	 */
	getExportUrl(apiName, param = '', mark = '') {
		const header = Const.NET.URL_POINT;
		const token = Data.getToken();
		mark = mark ? mark : this.auth('ADMIN') ? '/admin/1' : '/operator/1';
		let paramStr = '';
		for (const key in param) {
			if (param[key] == null || param[key] == undefined) { param[key] = ''; }
			paramStr += '&' + key + '=' + param[key];
		}
		let exportUrl = `${header}${mark}/${apiName}?token=${token}${paramStr}`;
		return exportUrl;
	},
	/** 图片内容处理 */
	imageFilter(item) {
		if (!item || typeof item !== 'string') {
			// console.warn("imageFilter 没有找到图像")
			return '';
		}
		if (item.includes('http')) {
			return item;
		} else {
			return Const.NET.IMG_URL_PREFIX + item;
		}
	},
	/** 检测字符串是否符合预设的正则规则
	 * @param {String} str 需要检测的字符串
	 * @param {String} type 正则规则类型
	 * @param {RegExp} custom 当type为"custom"需传入自定义正则
	 */
	regRuleTest(str = '', type, custom) {
		// console.log('regRuleTest str:', str, ' type:', type);
		str = str.toString();
		if (!str) {
			return false;
		}
		str.trim();
		let regRule = '';
		switch (type) {
			case 'int':
				regRule = /^[1-9]\d*$/;
				break; // 整数
			case 'float1':
				regRule = /^(\d+)(\.[0-9]{0,1})?$/;
				break; // 一位小数
			case 'float2':
				regRule = /^(\d+)(\.[0-9]{0,2})?$/;
				break; // 两位小数

			case '400':
				regRule = /^400([-]?)[0-9]{7}$/;
				break; // 400电话
			case '800':
				regRule = /^800([-]?)[0-9]{7}$/;
				break; // 800电话
			case 'phone':
				regRule = /^1[3456789]\d{9}$/;
				break; // 手机号
			case 'landline':
				regRule = /^(\d{1,3})([1-9]\d{1,2})([-]?)(\d{7,8})$/;
				break; // 固话
			case 'contact':
				regRule = /(^400([-]?)[0-9]{7}$)|(^800([-]?)[0-9]{7}$)|(^1[3456789]\d{9}$)|(^\d{1,3})([1-9]\d{1,2})([-]?)(\d{7,8}$)/;
				break; // 400正则 | 800正则 | 手机号 | 固话

			case 'idcard18':  // 身份证 18位
				regRule = /^([1-6][1-9]|50)\d{4}(18|19|20|21)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
				break;
			case 'idcard15':  // 身份证 15位
				regRule = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/;
				break;
			case 'password': // 长度8-25位，且须包含大小写字母和特殊字符(如!@#$%^&*)
				regRule = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\W_]).{8,25}$/
				break;

			case 'name': // 请输入中文、英文、数字或·/-/_，禁止表情和特殊符号
				regRule = /^[a-zA-Z0-9\u4e00-\u9fa5\·\-\_]*$/
				break;

			case 'email': // 邮箱格式校验
				regRule = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
				break;

			case 'custom':
				regRule = custom;
				break; // 手动传入正则规则
		}
		// console.log('regRule:', regRule);
		if (regRule) {
			console.log('regRule.test(str):', regRule.test(str))
			return regRule.test(str);
		}
		return false;

		/*
		let regRule = /^(?=.+[A-Z])(?=.+[a-z])(?=.+[\\W_])(?=.*\d).{8,25}$/
		let str = '123@abAb7'
		console.log('regRule.test(str)', regRule.test(str));
		*/
	},

	/** 字符串 改为预设的正则规则
	 * @param {String} str 需要检测的字符串
	 * @param {String} type 正则规则类型
	 * @param {RegExp} custom 当type为"custom"需传入自定义正则
	 */
	regRuleReplace(str = '', type, custom) {
		// console.log('regRuleReplace str:', str, ' type:', type);
		str = str.toString();
		if (!str) {
			return '';
		}
		str.trim();
		let replaceRule = '';
		switch (type) {
			case 'name': // 请输入中文、英文、数字或·/-/_，禁止表情和特殊符号
				replaceRule = /[^a-zA-Z0-9\u4e00-\u9fa5\·\-\_]/g
				break;
			case 'custom':
				replaceRule = custom;
				break; // 手动传入正则规则
		}
		str = str.replace(replaceRule, '');

		return str;
	},

	/** 设置权限信息到本地 */
	getAuthority(res, user) {
		console.log('getAuthority res:', res);
		const LOGIN_TYPE = Const.LOGIN_TYPE;
		const OPERATOR_MODE = Const.OPERATOR.MODE;
		let authorityList = res.authority_list || [];
		let authorityMap = {};
		switch (Data.getLoginType()) {
			case LOGIN_TYPE.ADMIN:
			case LOGIN_TYPE.ADMIN_MEMBER:
				authorityMap['ADMIN'] = true;
				break;
			case LOGIN_TYPE.OPERATOR:
			case LOGIN_TYPE.OPERATOR_MEMBER:
				authorityMap['OPERATOR'] = true;
				user = user || Data.getUser();

				// 特殊权限运营商
				const APP_NAME = process.env['VUE_APP_APP_NAME'];
				let operPath = user.path.split('/').filter((i) => i);
				// console.log('operPath:', operPath);
				let dahuaIds = [],
					hideSerIds = [],    // 仅隐藏自身的服务费板块
					hideMoreSerIds = [] // 隐藏自身及子账号的服务费板块
				// , hiddenEnergyServiceIds = []
				switch (APP_NAME) {
					case 'POWERLIBER':
					case 'POWERLIBERPRO':
					case 'POWERLIBERREL':
						dahuaIds = [
							'15580', /* 18969023238 */
							'16138', /* 17799869279 */
							'20158', /* 海盐县城市资产经营有限公司 */
							'11615', /* jiashi */
						];
						hideSerIds = [
							'18895', /* zxp-直营 */
							'17395', /* 华消 > HW7530 */
							'23803', /* 15910128083 */
						];
						hideMoreSerIds = [
							'11826', /* fjl-test1 */
							'20551', /* 华消 > 黄岩区充电桩 */
							'21623', /* 万兆科技 > 哎车家能源 */
                            // '16138', /* 17799869279 */
						];
						// TODO DSXNY 运营商不显示电费+服务费模板  注释
						// hiddenEnergyServiceIds = ['14052', '5513'];
						break;
					case 'POWERLIBERDEV':
						dahuaIds = [
							'15328', /* 18969023238 */
							'15788', /* 直营测试 */
						];
						hideSerIds = [
							'9367', /* zxp-直营0 */
							'23803', /* 15910128083 */
						];
						hideMoreSerIds = [];
						break;
				}
				if (dahuaIds.length) {
					for (const id of dahuaIds) {
						if (operPath.includes(id)) {
							authorityMap['DAHUA'] = true;
						}
					}
					if (operPath.length === 1 && dahuaIds.includes(operPath[0])) {
						authorityMap['DAHUA_MAIN'] = true;
					}
				}
				console.log('hideSerIds:', hideSerIds)
				if (hideSerIds.length && hideSerIds.includes(user.id+'')) {
					authorityMap['HIDDEN_SERVICE'] = true;
				}
				console.log('hideMoreSerIds:', hideMoreSerIds)
				if (hideMoreSerIds.length) {
					for (const id of hideMoreSerIds) {
						if (operPath.includes(id)) {
							authorityMap['HIDDEN_SERVICE'] = true;
						}
					}
				}

				// TODO DSXNY 运营商不显示电费+服务费模板  注释
				// console.log('hiddenEnergyServiceIds:', hiddenEnergyServiceIds)
				// if (hiddenEnergyServiceIds.length) {
				// 	console.log('user.id):', user.id)
				// 	if (hiddenEnergyServiceIds.includes(user.id+'')) {
				// 		authorityMap['HIDDEN_ENERGY_SERVICE'] = true;
				// 	}
				// }

				// 运营商 类型
				switch (user.mode) {
					case OPERATOR_MODE.DIRECTSALES:
						if (user.parent_mode === OPERATOR_MODE.DIRECTSALES) {
							// 直营的子级直营
							authorityMap['SUB_DIRECTSALES'] = true;
						} else {
							// 分销的子级直营
							authorityMap['DIRECTSALES'] = true;
						}
						break;
					case OPERATOR_MODE.DISTRIBUTOR:
						authorityMap['DISTRIBUTOR'] = true;
						break;
				}
				break;
			case LOGIN_TYPE.CLEARING_ACCOUNT:
				authorityMap['CLEARING_ACCOUNT'] = true;
				break;
		}
		for (const item of authorityList) {
			authorityMap[item.key] = true;
		}
		Data.setAuthority(authorityMap);
	},
	/** 按对象的某个字段排序
	 * @param {String} prop 字段名
	 * @param {Boolean} flag flag=false 从大到小, flag=true 从小到大
	 * @example list.sort(compare("count"))
	 */
	compare(prop, flag = false) {
		return function (obj1, obj2) {
			let val1 = obj1[prop];
			let val2 = obj2[prop];
			if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
				val1 = Number(val1);
				val2 = Number(val2);
			}
			if (val1 < val2) {
				return flag ? -1 : 1;
			} else if (val1 > val2) {
				return flag ? 1 : -1;
			} else {
				return 0;
			}
		}
	},
	hasKey(obj, key) {
		if (obj && obj.hasOwnProperty(key)) {
			return true
		}
		return false
	},
	// 严谨的获取对象的某个值
	getKey(obj, key, def = '') {
		if (typeof obj === 'object' && obj && obj.hasOwnProperty(key)) {
			return obj[key]
		} else {
			return def
		}
	},
	/** 判断两个数组内是否含有相同元素 */
	hasCommonElements(arr1, arr2) {
		return arr1.some(item => arr2.includes(item));
	},

	/** 动态加载外部链接 */
	loadJS(url) {
		const urlSp = url.split('://')
		urlSp[0] = window.location.protocol // http: | https:
		url = urlSp.join('//')
		console.log('loadJS url:', url)
		return new Promise((resolve) => {
			const head = document.getElementsByTagName('head')[0]
			const scriptList = head.getElementsByTagName('script')
			for (const script of scriptList) {
				if (script.src === url) {
					return resolve();
				}
			}

			const script = document.createElement('script');
			script.type = 'text/javascript';
			script.src = url;
			// IE
			if (script.readyState) {
				script.onreadystatechange = () => {
					if (script.readyState == 'loaded' || script.readyState == 'complete') {
						script.onreadystatechange = null;
						resolve();
					}
				};
			}
			// 其他浏览器
			else {
				script.onload = function () {
					resolve();
				};
			}
			document.getElementsByTagName('head')[0].appendChild(script);
		})
	},

	waitTime(time) {
		console.log('延时开始', time, new Date().valueOf());
		return new Promise((resolve) => setTimeout(() => {
			resolve()
			console.log('延时结束', time, new Date().valueOf());
		}, time));
	},

	/* 去除所有零宽字符 */
	removeAllZeroWidthChars(str) {
		return str.replace(/[\u200B-\u200D\uFEFF\u200C]/g, '');
	},
	/* ======== 通用方法 ========== */


	/* ======== 数值处理 ========== */
	/**
	 * 将1-20以内的阿拉伯数字转换为中文
	 * @param {Number} value 1-20以内的阿拉伯数字
	 */
	chNumFilter(value) {
		if (!value) {
			return '';
		}
		const CH_NUM_MAP = {
			0: '零',
			1: '一',
			2: '二',
			3: '三',
			4: '四',
			5: '五',
			6: '六',
			7: '七',
			8: '八',
			9: '九',
			10: '十',
			11: '十一',
			12: '十二',
			13: '十三',
			14: '十四',
			15: '十五',
			16: '十六',
			17: '十七',
			18: '十八',
			19: '十九',
			20: '二十',
		};
		return CH_NUM_MAP[value] || value;
	},
	/**
	 * @description:数值转换 将后端传来的数值转换成对应值
	 * @param {Number} val 被除数 需要转换的数值
	 * @param {Number} divisor 除数 默认为100
	 * @param {Number} dp 保留几位小数 默认为2
	 * @param {Number} type 乘法/除法 false=除法 true=乘法
	 */
	countFilter(val = 0, divisor = 100, dp = 2, type = false) {
		if (val == 0) {
			return 0;
		}
		if (type) {
			return parseFloat((val * divisor).toFixed(dp));
		} else {
			return parseFloat((val / divisor).toFixed(dp));
		}
	},
	/**
	 * @description:用法同countFilter 但保留小数位后不会再转换成数值
	 */
	moneyFilter(val = 0, divisor = 100, dp = 2, type = false) {
		if (val == 0) {
			let v = 0;
			return v.toFixed(dp);
		}
		if (type) {
			return (val * divisor).toFixed(dp);
		} else {
			return (val / divisor).toFixed(dp);
		}
	},
	/*
	 * @description:用法同moneyFilter 不四舍五入 截取为两位小数
	 */
	cutMoneyFilter(val = 0, divisor = 100, dp = 2) {
		// 先切割   4666600 --> 4660000
		val = this.moneyIntercept(val, divisor, true);

		// 4660000 --> 4.66
		val = this.moneyFilter(val, divisor, dp);
		return val;
	},

	/** 格式化数字，小于10的数字前面加0
	 * @param {Number} num 需要格式化的数字
	 * @returns {String} 格式化后的字符串
	 */
	formatNumber(num) {
		if (typeof num !== 'number') {
			return num;
		}
		return num < 10 ? `0${num}` : `${num}`;
	},

	// 控制数字保留几位小数（不四舍五入）
	cutMoneyBySlice(val = 0, divisor = 100, dp = 2) {
		if (divisor === 0) {
			return val.toFixed(dp);
		}

		val = this.moneyFilter(val, divisor, dp + 1);

		val = val.slice(0, -1);

		return Number(val);
	},
	/* ======== 数值处理 ========== */


	/* ======== 结算账户 ========== */
	/**
	 * 获取 微信OpenId 二维码
	 */
	openIdQrcode(flag = false) {
		let APP_NAME = process.env.VUE_APP_APP_NAME;
		let imgType = 'bolai';
		switch (APP_NAME) {
			case 'POWERLIBER':
			case 'POWERLIBERDEV':
			case 'POWERLIBERPRO':
				imgType = 'bolai';
				break;
			case 'LEIFENG':
				imgType = 'leifeng';
				break;
			case 'QIANNIU':
				imgType = 'qianniu';
				break;
			case 'YUANDIAN':
				imgType = 'yuandian';
				break;
			case 'AIMA':
				imgType = 'aima';
				break;
		}
		return require(`@/assets/images/openId/openid_page_${imgType}${flag ? '_h5' : ''}.png`);
	},
	/* ======== 结算账户 ========== */


	/* ======== 设备管理 ========== */
	/**
	 * 
	 * 获取设备的插口数量
	 */
	getPortCount({ uid, model_type, port_count }) {
		// 直接返回设备的插口数量
		return port_count;

		// 之前判断设备的端口数量的代码
		// 根据设备UID的前两位(或前四位)和设备的model_type，返回设备的插口数量
		// if (model_type % 2 == 1) {
		// 	return 1;
		// }

		// let mark = Number(this.uidSlice(uid));

		// let one = [11,12,51,53,54,55,57,58,1013,1014,1018,1019,1025,1028,1029,1032,1033,1034,9001,1091,1096,1097]
        // let two = [
		// 	13,14,16,17,
        //     20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,45,46,47,48,49,50,52,56,70,71,73,74,
        //     80,85,86,88,1011,1012,1015,1016,1017,1020,1022,1026,1027,1024,1035,1039,1040,1041,1042,1043,1050,1051,
		// 	1060,
		// 	1076,1077,1083,1087,1089,1094,
        //     9002,9101
        // ]
        // let four = [1071,1072,1073,1075,1082]
        // let five = [1088]
        // let six = [61,62]
        // let eight = [1086]
        // let ten = [72,87,95,96,98,99,1002,1003,1008,1009,1036,1047,1048,1049,1059]
        // let twelve = [81,90,91,92,93,94,1004,1005,1006,1007,1030,1031,1037]
        // let sixteen = [1090]
        // let self = [44,43,1000,1001,1010,1038,1044,1045,1046,1052,1074]
		// if (   two.includes(mark)) { return 2; }
		// if (   one.includes(mark)) { return 1; }
		// if (  four.includes(mark)) { return 4; }
		// if (  five.includes(mark)) { return 5; }
		// if (   six.includes(mark)) { return 6; }
		// if ( eight.includes(mark)) { return 8; }
		// if (   ten.includes(mark)) { return 10; }
		// if (twelve.includes(mark)) { return 12; }
		// if (sixteen.includes(mark)) { return 16; }
		// if (  self.includes(mark)) { return port_count; }
		// return port_count || 2;
	},

	/** 处理设备uid */
	uidSlice(uid) {
		try {
			if (!uid) {
				throw {
					message: 'uid错误',
				}
			}
			let mark = (uid.length === 16 || uid.length === 14) ? uid.slice(0, 4) : uid.slice(0, 2);
			return mark;
		} catch (err) {
			console.log("uid err:", err);
			return '';
		}
	},
	/** 设备类型 标记 */
	deviceTypeMark(device) {
		try {
			let flag = {
				mark: '',
				type: '',                         // 设备类型
				device_car: false,                // 汽车充设备
				device_single_car: false,         // 单枪汽车充设备
				device_double_car_special: false, // 双枪汽车充设备 port_index 从1开始
				device_tank: false,               // 充电柜设备
				device_cabinet: false,            // 换电柜设备
				device_gate: false,               // 道闸设备
				device_plug: false,               // 两轮充设备
			};

			if (this.isEmptyObj(device)) {
				return flag;
			}

			let mark;

			const {
				uid,     // uid规则
				type,    // 设备类型
				port_count,   // 端口数量
			} = device;

			mark = this.uidSlice(uid);
			flag.type = type;
			if (!mark) {
				return flag;
			}

			let MARK = Const.DEVICE.CATEGORY_TYPE_MARK;

			let PORT_MARK = Const.DEVICE.PORT_MARK;

			flag.mark = mark;
			flag.device_car = MARK.CAR.includes(type);                // 汽车充设备

			/**
			 * 处理特殊设备
			 * 
			 * 1.是汽车充设备且端口数量为1，则显示右枪
			 * 2.是云快充汽车充设备且端口数量大于1，port_index 从1开始
			 * 
			 */
			// && PORT_MARK.SINGLE_CAR.includes(mark)
			flag.device_single_car = MARK.CAR.includes(type) && port_count === 1;  // 单枪汽车充设备  全部显示右枪
			// port_count === 2 && (PORT_MARK.DOUBLE_CAR_SPECIAL.includes(mark))
			flag.device_double_car_special = MARK.CAR_YKC.includes(type) && port_count > 1;  // 双枪汽车充设备 port_index 从1开始   针对云快充
			
			flag.device_tank = MARK.TANK.includes(type);              // 充电柜设备
			flag.device_cabinet = MARK.CABINET.includes(type);        // 换电柜设备
			flag.device_plug = MARK.PLUG.includes(type);              // 两轮充设备
			flag.device_gate = PORT_MARK.GATE.includes(mark);         // 道闸设备


			


			// 原来的代码
			// mark = this.uidSlice(device.uid);
			// if (!mark) {
			// 	return flag;
			// }
			// let MARK = Const.DEVICE.PORT_MARK;
			
			// flag.mark = mark;
			// flag.device_car = MARK.CAR.includes(mark);                // 汽车充设备
			// flag.device_single_car = MARK.SINGLE_CAR.includes(mark);  // 单枪汽车充设备
			// flag.device_double_car_special = MARK.DOUBLE_CAR_SPECIAL.includes(mark);  // 双枪汽车充设备 port_index 从1开始
			// flag.device_tank = MARK.TANK.includes(mark);              // 充电柜设备
			// flag.device_cabinet = MARK.CABINET.includes(mark);        // 换电柜设备
			// flag.device_gate = MARK.GATE.includes(mark);              // 道闸设备
			// flag.device_plug = MARK.PLUG.includes(mark);              // 两轮充设备

			return flag;
		} catch (err) {
			console.log("deviceTypeMark err:", err);
			return {};
		}
	},

	/** 获取订单中的设备端口名字 */
	getOrderPortName(order) {
		try {
			if (!order || this.isEmptyObj(order)) {
				// 没有订单，返回'-'
				return '-';
			}

			// 判断 order 里面有没有port_index, device_type, device_port_count这几个字段，都没有返回port_name，有执行后面的代码
			if (!order.hasOwnProperty('port_index') || !order.hasOwnProperty('device_type') || !order.hasOwnProperty('device_port_count')) {
				// 没有所需字段，返回port_name或'-'
				return order.port_name ? `${order.port_name}口` : '-';
			}
			
			let name = this.getPortName(order);
			// console.log("getOrderPortName ~ name:", name);

			return name;
		} catch (err) {
			console.log("uid err:", err);
			return '';
		}
	},

	/** 获取端口名字
	 * @param {Object} info 端口信息对象
	 * @param {String} label 端口标签，默认为'口'
	 * @param {Boolean} useFormatNumber 是否使用formatNumber格式化数字，默认为false
	 */
	getPortName(info, label = '口', useFormatNumber = false) {
		try {
			if (!info || this.isEmptyObj(info)) {
				// 没有订单，返回'?'
				return '?';
			}

			// 判断 info 里面有没有port_index, device_type, device_port_count这几个字段，都没有返回?，有执行后面的代码
			if (!info.hasOwnProperty('port_index') || !info.hasOwnProperty('device_type') || !info.hasOwnProperty('device_port_count')) {
				// 没有所需字段，返回'?'
				return '?';
			}

			const { port_index, device_type, device_port_count} = info;
			const PORT_INDEX_PORT_NAME = Const.DEVICE.PORT_INDEX_PORT_NAME;

			/**
			 * PC端、B端、C端，充电订单，充电端口展示：
			 * 
			 * 两轮充
			 * 1个端口，"B口"，port_index=1
			 * 2个端口，"A口、B口"，port_index=0、1
			 * >=3个端口，"1口、2口、3口、..."，port_index=0、1、2...
			 * 
			 * 公版协议汽车充
			 * 单枪，"右口"，port_index=1
			 * 双枪，"左口、右口"，port_index=0、1
			 * 多枪，"1口、2口、3口、..."，port_index=0、1、2...
			 * 
			 * 云快充协议汽车充
			 * 单枪，"右口"，port_index=1
			 * 双枪，"左口、右口"，port_index=1、2
			 * 多枪，"1口、2口、3口、..."，port_index=1、2、3...
			 * 
			 * 充电柜
			 * 多仓，"1口、2口、3口、..."port_index=0、1、2...			
			 * 
			 * 换电柜
			 * 多仓，"1口、2口、3口、..."port_index=0、1、2...
			 */

			const {
				device_car = false,         // 汽车充设备
				device_single_car = false,  // 单枪汽车充设备
				device_double_car_special = false,  // 双枪汽车充设备 port_index 从1开始
				device_tank = false,        // 充电柜设备
				device_cabinet = false,     // 换电柜设备
				device_gate = false,        // 道闸设备
				device_plug = false,        // 两轮充设备
			} = this.deviceTypeMark({
				type: device_type,
				port_count: device_port_count,
				uid: '1234567890', // 这个地方不需要uid,先不传真实的值
			});

			let name = '';

			if (device_plug) {

				// 两轮充
				if (device_port_count <= 2) {
					name = PORT_INDEX_PORT_NAME.PLUG[port_index];
				} else {
					name = useFormatNumber ? this.formatNumber(port_index + 1) : (port_index + 1);
				}

			} else if (device_double_car_special) {

				// 云快充协议汽车充
				if (device_port_count === 1) {
					name = PORT_INDEX_PORT_NAME.CAR[port_index];
				} else if (device_port_count === 2) {
					// port_index 从1开始
					name = PORT_INDEX_PORT_NAME.SPECIAL_CAR[port_index];
				} else {
					// port_index 从1开始
					name = useFormatNumber ? this.formatNumber(port_index) : port_index;
				}

			} else if (device_car) {

				// 公版协议汽车充
				if (device_port_count <= 2) {
					name = PORT_INDEX_PORT_NAME.CAR[port_index];
				} else {
					name = useFormatNumber ? this.formatNumber(port_index + 1) : (port_index + 1);
				}

			} else if (device_tank) {

				// 充电柜
				name = useFormatNumber ? this.formatNumber(port_index + 1) : (port_index + 1);

			} else if (device_cabinet) {

				// 换电柜
				name = useFormatNumber ? this.formatNumber(port_index + 1) : (port_index + 1);

			}

			name = name ? `${name}${label}` : '?';

			return name;
		} catch (err) {
			console.log("uid err:", err);
			return '';
		}
	},

	/** 获取错误日志中的端口名字 */
	getErrorLogPortName(log) {
		try {
			if (!log || this.isEmptyObj(log)) {
				// 没有错误日志，返回'-'
				return '-';
			}

			let data = log.data ? JSON.parse(log.data) : {};

			// 判断 data 里面有没有port_index, device_type, device_port_count这几个字段，都没有返回 - ，有执行后面的代码
			if (!data.hasOwnProperty('port_index') || !data.hasOwnProperty('device_type') || !data.hasOwnProperty('device_port_count')) {
				// 没有所需字段，返回'-'
				return '-';
			}

			const { port_index, device_type, device_port_count } = data;

			let name = this.getPortName({
				device_type,
				device_port_count,
				port_index,
			}, '', false);

			name = name ? `${name}` : '-';

			return name;
		} catch (err) {
			console.log("uid err:", err);
			return '-';
		}
	},

	/** 获取设备规格config对应字段 */
	getDeviceModelConfigKeyByDeviceType(device = {}) {
		try {
			if (this.isEmptyObj(device)) {
				throw {
					message: '设备为空',
				}
			};

			const CATEGORY_TYPE_MARK = Const.DEVICE.CATEGORY_TYPE_MARK;

			if (CATEGORY_TYPE_MARK.SET_SINGLE_PARAMETER.includes(device.type)) {
				// 可以设置单路参数
				// 单路最大输出功率
				return 'single_port_max_output_power';
			} else if (CATEGORY_TYPE_MARK.TANK.includes(device.type)) {
				// 充电柜
				// 单仓额定输出功率
				return 'single_port_rated_output_power';
			} else {
				// 整机额定输出功率
				return 'rated_output_power';
			}
		} catch (err) {
			console.log("getDeviceConfigByUid err:", err);
			return '';
		}
	},

	/** 获取设备规格config对应字段的值 */
	getDeviceModelConfigByKey(device_model = {}, to = 'single_port_max_output_power') {
		try {
			if (this.isEmptyObj(device_model)) {
				throw {
					message: '设备规格数据为空',
				}
			};

			// 解析config
			let config= JSON.parse(device_model.config) || {};

			return config[to] || 2200;
		} catch (err) {
			console.log("getDeviceConfigByUid err:", err);
			return 2200;
		}
	},

	/** 通过设备前2/4位 获取 设备名称 及 允许最大功率 */
	getDeviceInfoByUid(uid, to = 'word') {
		try {
			if (!uid) {
				throw {
					message: 'uid错误',
				}
			};

			let mark = Number(this.uidSlice(uid));
			switch (to) {
				case 'word':
					switch (mark) {
						case 11:
						case 12: return '二代组网大功率单路插座'

						case 13: return '五代3500W组网插座'
						case 14: return '五代3500W插座网关'
						case 16: return '五代2200W组网插座'
						case 17: return '五代2200W插座网关'

						case 20: return '二代2G独立版插座'
						case 21:
						case 22:
						case 23: return '二代组网插座'
						case 24: return '二代2G独立版插座'
						case 25:
						case 26:
						case 27: return '二代组网插座'
						case 28:
						case 29: return '二代2G独立版插座'

						case 30: return '三代2G独立版插座'
						case 31:
						case 32: return '三代组网插座'
						case 33: return '两路智能充电桩(无线)2200W'
						case 34: return '三代2G独立版插座'
						case 35:
						case 35: return '三代组网普通功率插座'
						case 37: return '两路智能充电桩(无线)'
						case 38:
						case 39: return '三代5G-NB大功率插座'

						case 40: return '四代3500W组网插座'
						case 41: return '四代组网插座'
						case 42: return '四代3500W4G独立版'
						case 43:
						case 44: return '充电柜'
						case 45: return '三代组网大功率插座'
						case 46: return '分布式充电桩（2端口）'
						case 47: return '三代4G独立版大功率插座'
						case 48: return '三代5G-NB大功率插座'
						case 49: return '三代大功率插座'

						case 50: return '三代安全插座'
						case 51: return '交流汽车充单枪'
						case 52: return '交流汽车充双枪'
						case 53: return '交流汽车充单枪(家庭版)'
						case 54: return '雷风汽车充单枪带屏4G独立版'
						case 55: return '交流汽车充单枪(不带屏)'
						case 56: return '交流汽车充单枪(不带屏)'

						case 57: return '单口4G独立版'

						case 58: return '交流桩道闸一体机'

						case 61: return '六路机'
						case 62: return '六路机'

						case 70: return '三代组网大功率插座'
						case 71: return '三代组网大功率插座'
						case 72: return '雷风10路机'
						case 73: return '奋成新主板'
						case 74: return '景观式充电桩组网插座'

						case 80: return '四代3500W插座网关'
						case 81: return '12路主机'
						case 82: return '4G+470M'
						case 83: return '4G+Lora'
						case 84: return '网线网关'
						case 85: return '三代网关插座'
						case 86: return '三代网关插座'   // 分布式充电桩（1端口）
						case 87: return '10路主机'
						case 88: return '三代蓝牙插座网关'
						case 89: return '三代2.4G插座网关'

						case 90: return '十二路机'
						case 91: return '柏来带显12路机'
						case 92: return '12路4G独立版'
						case 93: return '迦一12路机'
						case 94: return '12路从机'
						case 95: return '10路4G独立版'
						case 96: return '10路从机'
						case 98: return '10路机'
						case 99: return '闪开10路机'

						case 1000: return '换电柜主控板'
						case 1001: return '换电柜仓控板'
						case 1002: return '集采十路机高配版'
						case 1003: return '十路钣金精华版'
						case 1004: return '千牛十二路带显示4G独立版'
						case 1005: return '十二路不带显示4G独立版'
						case 1006: return '12路机带显示4G独立版'
						case 1007: return '12路机不带显示4G独立版'
						case 1008: return '10路带显示4G独立版'
						case 1009: return '10路不带显示4G独立版'

						case 1010: return '换电柜DTU'
						case 1011: return '汽车充双枪带屏4G独立版'
						case 1012: return '汽车充双枪不带屏4G独立版'
						case 1013: return '汽车充单枪带屏4G独立版'
						case 1014: return '汽车充单枪不带屏4G独立版'
						case 1015: return '并联控制器'
						case 1016: return '汽车充双枪带屏4G独立版'  // 为远汽车充双枪带屏4G独立版
						case 1017: return '汽车充双枪不带屏4G独立版'  // 为远汽车充双枪不带屏4G独立版
						case 1018: return '交流汽车充单枪'  // 为远汽车充单枪带屏4G独立版
						case 1019: return '汽车充单枪不带屏4G独立版'  // 为远汽车充单枪不带屏4G独立版

						case 1020: return '铅锂快充桩'
						case 1022: return '直流桩(120KW双枪)'
						case 1023: return '直流桩(120KW双枪)'
						case 1024: return '柏来车位道闸'
						case 1025: return '汽车充单枪家庭版不带屏'
						case 1026: return '直流桩(120KW双枪)'
						case 1027: return '直流桩(60KW双枪)'
						case 1028: return '直流桩(30KW单枪)'
						case 1029: return '直流桩(60KW单枪)'

						case 1030: return '12路带显4G独立版'
						case 1031: return '12路不带显4G独立版'
						case 1032: return '直流桩(20KW单枪)'
						case 1033: return '直流桩(40KW单枪)'
						case 1034: return '直流桩(80KW单枪)'
						case 1035: return '直流桩(80KW双枪)'
						case 1036: return 'HK定制款10路机'
						case 1037: return 'HK定制款12'
						case 1038: return 'HK定制款20'
						case 1039: return '直流桩(180KW双枪)'

						case 1040: return '直流桩(40KW双枪)'
						case 1041: return '直流桩(160KW双枪)'
						case 1042: return '直流桩(240KW双枪)'
						case 1043: return '直流桩(320KW双枪)'
						case 1044: return '直流桩(群充终端)CCU控制板'
						case 1045: return '直流桩(群充主机)PCU控制板'
						case 1046: return '直流桩(群充主机)PDU控制板'
						case 1047: return '钣金款10路线上计量款'
						case 1048: return '钣金款10路线上计时款'
						case 1049: return '10路不带显4G独立版'

						case 1050: return '全能一号4G独立版'
						case 1051: return '景观式充电桩独立版'
						case 1052: return '钣金款20路机4G独立版'

						case 1059: return '上海巨气10路机4G独立版'
						case 1060: return '直流桩(400KW双枪)'

						case 1071: return '直流桩(160KW一机四枪)'
						case 1072: return '直流桩(200KW一机四枪)'
						case 1073: return '直流桩(240KW一机四枪)'

						case 1074: return '20路4G独立版(带投币)'

						case 1075: return '直流桩(180KW一机四枪)'

						case 1076: return '五代3500W4G独立版'
						case 1077: return '五代2200W4G独立版'

						case 1082: return '二代景观四路2200W独立版'
						 
						case 1083: return '直流桩(360KW双枪同充)'
						case 1086: return '直流桩(480KW一机八枪)'
						
						case 1087: return '智享4G Open独立版'

						case 1088: return '独立版五路机'
						
						case 1089: return '群充终端'
						
						case 1090: return '独立版十六路机'
						case 1091: return '液冷超充单枪终端'
						case 1094: return '大功率智能充电终端'
						case 1096: return '三相单口大功率充电桩'
						case 1097: return '三相21KW单枪汽车交流桩'

						case 1200: return '隔断式充电桩主控板'

						case 9001: return '云快充交流充电桩单枪'
						case 9002: return '云快充交流充电桩双枪'
						case 9101: return '云快充120KW双枪直流桩'

						default: return '未知'
					}
				case 'power':
					switch (mark) {
						case 11:
						case 12: return 3500
						case 21:
						case 22:
						case 24:
						case 25:
						case 26:
						case 35:
						case 37:
						case 43:
						case 44: return 800
						case 33:
						case 38:
						case 45:
						case 47:
						case 48:
						case 54:
						case 70:
						case 71:
						case 88:
						case 89:
						case 1011:
						case 1012:
						case 1013:
						case 1014:
						case 85: return 2200
						case 40:
						case 42:
						case 80: return 3500
						case 51:
						case 52:
						case 53:
						case 54:
						case 55:
						case 56: return 7000
						case 61:
						case 62: return 1500
						case 87:
						case 90:
						case 91:
						case 92:
						case 95:
						case 96:
						case 98: return 1100
						default: return 2200
					}
			}
		} catch (err) {
			console.log("getDeviceConfigByUid err:", err);
			return '-';
		}
	},

	/**
	 * @description 根据设备UID的前两位(或前四位)返和位置名称，返回设备或充电单元的名称
	 * @param {String} uid 设备uid
	 * @param {String} key  p：插口(port)  d：插座(device) sp：插口简称
	 */
	getDeviceName(uid, key = 'p') {
		const PORT_MARK = Const.DEVICE.PORT_MARK;
		let mark = Number(this.uidSlice(uid));

		if (PORT_MARK.CAR.includes(mark)) {
			switch (key) {
				case 'sp':
					return '枪';
				case 'p':
					return '充电枪';
				case 'd':
					return '充电桩';
			}
			return '';
		} else if (PORT_MARK.TANK.includes(mark)) {
			switch (key) {
				case 'sp':
					return '仓';
				case 'p':
					return '充电仓';
				case 'd':
					return '充电柜';
			}
			return '';
		} else if (PORT_MARK.CABINET.includes(mark)) {
			switch (key) {
				case 'sp':
					return '仓';
				case 'p':
					return '换电仓';
				case 'd':
					return '换电柜';
			}
			return '';
		} else {
			switch (key) {
				case 'sp':
					return '孔';
				case 'p':
					return '插口';
				case 'd':
					return '插座';
			}
			return '';
		}
	},
	getDeviceNameByType(device_type, key = 'p') {
		const TYPE = Const.DEVICE.TYPE;
		switch (device_type) {
			case TYPE.CAR_AC:
			case TYPE.CAR_DC:
				switch (key) {
					case 'sp':
						return '枪';
					case 'p':
						return '充电枪';
					case 'd':
						return '充电桩';
				}
				return '';
			case TYPE.TANK:
				switch (key) {
					case 'sp':
						return '仓';
					case 'p':
						return '充电仓';
					case 'd':
						return '充电柜';
				}
				return '';
			case TYPE.CABINET:
				switch (key) {
					case 'sp':
						return '仓';
					case 'p':
						return '换电仓';
					case 'd':
						return '换电柜';
				}
				return '';
			default:
				switch (key) {
					case 'sp':
						return '孔';
					case 'p':
						return '插口';
					case 'd':
						return '插座';
				}
				return '';
		}
	},
	getDeviceNameByChargeMode(charge_mode, key = 'p') {
		const MARK = Const.CHARGE.CHARGE_MODE_MARK

        if (MARK.TANK.includes(charge_mode)) {
            switch (key) {
                case 'p': return '充电仓'
                case 'sp': return '仓'
                case 'd': return '充电柜'
            } return ''
        }
        else if (MARK.CAR.includes(charge_mode)) {
            switch (key) {
                case 'p': return '充电枪'
                case 'sp': return '枪'
                case 'd': return '充电桩'
            } return ''
        }
        else {
            switch (key) {
                case 'p': return '端口'
                case 'sp': return '口'
                case 'd': return '设备'
            } return ''
        }
	},
	/* ======== 设备管理 ========== */

	/* ======== 站点管理 ========== */
	/**
	 * 处理已经创建的站点的设备类型
	 */
	disposeOldStationDeviceType(device_type) {
		const DEVICE_TYPE = Const.DEVICE.TYPE;
		switch (device_type) {
			case DEVICE_TYPE.INDEPENDENT:  // 独立版 旧
			case DEVICE_TYPE.SIX_WAY:  // 六路机
			case DEVICE_TYPE.TEN_WAY:  // 十路机
			case DEVICE_TYPE.TWELVE_WAY:  // 十二路机
			case DEVICE_TYPE.TWENTY_WAY:  // 二十路机
				// 独立版（旧）、六路机、十路机、十二路机、二十路机，显示成"独立版（新）"
				return DEVICE_TYPE.NEW_INDEPENDENT;   // 显示为
			default:
				return device_type;
		}
	},
	/**
	 * 可批量设置充电参数
	 * 
	 * 以下设备支持
	 * 十二路机
	 * 二十路机
	 * 十路机
	 * 五路机
	 * 十六路机
	 * 
	 * 返回true   一般设备充电参数（不支持每个孔设置最大充电功率）
	 * 返回false  支持每个孔设置最大充电功率
	 */
	canMultipleSet({ type }) {
		try {
			const CATEGORY_TYPE = Const.DEVICE.CATEGORY_TYPE;
			switch (type) {
				case CATEGORY_TYPE.TWELVE_WAY: // 十二路机
				case CATEGORY_TYPE.TWENTY_WAY:  // 二十路机
				case CATEGORY_TYPE.TEN_WAY:  // 十路机
				case CATEGORY_TYPE.FIVE_WAY:  // 五路机
				case CATEGORY_TYPE.SIXTEEN_WAY:  // 十六路机
					return false
				default:
					return true
			}
		} catch (err) {
			console.log("canMultipleSet ~ err:", err)
			return true;
		}
	},
	/**
	 * 是否显示批量更改参数
	 * 
	 * 返回true   支持多选
	 * 返回false  不支持多选
	 */
	canMultipleSetRowSelection(deviceType, device_list = []) {
		try {
			// console.log("device_list:", device_list)
			// console.log("deviceType:", deviceType)
			const DEVICE_TYPE = Const.DEVICE.TYPE;
			const CATEGORY_TYPE_MARK = Const.DEVICE.CATEGORY_TYPE_MARK;
			switch (deviceType) {
				case DEVICE_TYPE.TWELVE_WAY: // 十二路机
				case DEVICE_TYPE.TWENTY_WAY:  // 二十路机
				case DEVICE_TYPE.TEN_WAY:  // 十路机
					return false;
				case DEVICE_TYPE.NEW_INDEPENDENT:  // 新独立版   可以理解为21004，包含了独立版、六路机、十二路机、十路机、二十路机、五路机、十六路机
					// 需要根据站点下的当页设备在进行判断
					// 有除了独立版、六路机的其他设备  不支持多选
					if (!device_list.length) {
						return false;
					}
					// 判断device_list有没有一项的type不在CATEGORY_TYPE_MARK下SHOW_MULTIPLE_SET_ROW_SELECTION
					// 只要有一项不在，就是false,否则是true
					const hasInvalidType = device_list.some(item => {
						return !CATEGORY_TYPE_MARK.SHOW_MULTIPLE_SET_ROW_SELECTION.includes(item.type);
					});
					return !hasInvalidType;
				default:
					return true;
			}
		} catch (err) {
			console.log("canMultipleSetRowSelection ~ err:", err)
			return false;
		}
	},
	/* ======== 站点管理 ========== */


	/* ======== 电池管理 ========== */
	// 电池类型
	packTypeFilter(val, to = 'text') {
		const MAP = Const.PACK.TYPE_MAP;
		const ITEM = MAP[val + ''] || {};
		return ITEM[to] || '-';
	},
	/* ======== 电池管理 ========== */
	/* ======== 用户规则管理 ========== */
	// 规则更新记录
	userRuleTypeFilter(val, to = 'text') {
		const MAP = Const.USER_RULE.LOG_TYPE_MAP;
		const ITEM = MAP[val + ''] || {};
		return ITEM[to] || '-';
	},
	// 站点类型
	stationTypeFilter(val, to = 'text') {
		const MAP = Const.STATION.TYPE_MAP;
		const ITEM = MAP[val + ''] || {};
		return ITEM[to] || '-';
	},
	/* ======== 用户规则管理 ========== */
	/* ======== 白名单、黑名单 ========== */
	// 站点类型
	panelActionListTypeFilter(val, to = 'text') {
		const MAP = Const.PANEL_ACTION_LIST.TYPE_MAP;
		const ITEM = MAP[val + ''] || {};
		return ITEM[to] || '-';
	},
	/* ======== 用户规则管理 ========== */


	/* ======== 订单管理 ========== */
	async getCharingPayMethodList(type = 'list') { // list: 列表选择、export: 充电订单导出选择（去除先充后付免费）
		const LIST = Object.values(Const.PAY.METHOD_MAP)

		// 管理员 => 可以看见全部
		if (this.auth('ADMIN')) { 
            if (type === 'list') {
                return LIST.map(i => ({...i, text: i.admin_text ? i.admin_text : i.text})) 
            } else {
                return LIST.filter(i => i.auth_key !== 'admin')
            }
        }

		// 运营商
		const authList = [];

		// 检查是否开启青橄榄支付
		try {
			const { operator } = await Api.Operator.detail()
			if (operator.flag_qgl_pay) {
				authList.push('qingganlan')
			}
		} catch (err) {}

		// 检查是否开启哈啰推送
		try {
			const {flag_hello} = await Api.Operator.checkHaluo()
			console.log('getCharingPayMethodList checkHaluo:', flag_hello)
			if (flag_hello) {
				authList.push('haluo')
			}
		} catch (err) {}

		let list = LIST.filter(item => {
			return !item.auth_key || authList.includes(item.auth_key)
		})
		console.log('getCharingPayMethodList list:', list)
		return list
	},
	// 汽车充
	getCarSerChargeModel(model, isShowSix) {
		// isShowSix: 站点是否开启新计费模式，展示六位小数
		let max = 0,
			min = 9999999;
		let currIndex = 0;
		let curr = dayjs().year(2000).month(0).date(1);
		if (!model || !model.hasOwnProperty('list') || model.mode !== Const.CHARGE.TYPE.CAR_SERVICE) {
			return { currIndex, detail: {}, list: [], max, min };
		}
	
		let timeLabel = '2000-01-01'
	
		try {
			/**
			 * hour, minute: Number
			 * energy_price, service_price: Number
			 * total: Number
			 * end_time, begin_time: HH:mm
			 * begin, end: dayjs
			 */
			model.list.forEach((i, index) => {
				i.end_time = dayjs().hour(i.hour).minute(i.minute).format('HH:mm');
				if (index === 0) {
					i.begin_time = '00:00';
				} else {
					let last_end_time = model.list[index - 1];
					i.begin_time = dayjs()
						.hour(last_end_time.hour)
						.minute(last_end_time.minute + 1)
						.format('HH:mm');
				}
	
				i.begin = dayjs(`${timeLabel} ${i.begin_time}:00 000`);
				i.end = dayjs(`${timeLabel} ${i.end_time}:59 999`);
				// i.begin = dayjs(`2000-01-01 ${i.begin_time}:00 000`);
				// i.end = dayjs(`2000-01-01 ${i.end_time}:59 999`);
				i.total = i.energy_price + i.service_price;
	
				// i.total = i.energy_price + i.service_price;
				if (isShowSix) {
					i.total = i.energy_price_6 ? i.energy_price_6 + i.service_price_6 : i.energy_price + i.service_price;
				} else {
					i.total = i.energy_price + i.service_price;
				}
	
				if (i.total > max) {
					max = i.total;
				}
				if (i.total < min) {
					min = i.total;
				}
				// i.order = index + 1;
	
				// console.log('curr:', curr.format('YYYY-MM-DD HH:mm:ss SSS'), 'begin:', i.begin.format('YYYY-MM-DD HH:mm:ss SSS'), 'end:', i.end.format('YYYY-MM-DD HH:mm:ss SSS'));
				if (curr.isBetween(i.begin, i.end, null, '[]')) {
					currIndex = index;
				}
			});
		} catch (error) {
			console.log('getCarSerChargeModel error:', error);
		} finally {
			return { currIndex, detail: model, list: model.list, max, min, timeLabel };
		}
	},
	/**
	 * 获取汽车充占位模板
	 * @param {*} model 模板信息
	 * @param {*} stage  计费阶段
	 * @returns 
	 */
	getCarChargeOccupyModel(model, stage = 'before') {
		let currIndex = 0;
		let curr = dayjs().year(2000).month(0).date(1);
		let timeLabel = '2000-01-01'
		if (!model || model.mode !== Const.CHARGE.TYPE.CAR_OCCUPY) {
			return { currIndex, detail: {}, list: [] };
		}

		// 占位信息
		let config = {};
		switch (stage){
			case 'before':
				// 充电前
				config = model.charge_pre_occupy_fee_config || {};
			break;
			case 'after':
				// 充电后
				config = model.charge_finish_occupy_fee_config || {};
			break;
		}

		if (this.isEmptyObj(config)) {
			return { currIndex, detail: {}, list: [] };
		}

		let occupy_list = [];
		const CAR_OCCUPY_MODE = Const.CHARGE.CAR_OCCUPY.MODE;
		// 收费模式
		switch (model.charge_mode) {
			case CAR_OCCUPY_MODE.MONEY:
				// 一口价
				occupy_list = [
					{
						hour: 23, 
						minute: 59, 
						price: config.occupy_price || 0,
					}
				]
			break;
			case CAR_OCCUPY_MODE.TIME:
				// 实时计费
				occupy_list = config.occupy_list || [];
			break;
		}
		if (!occupy_list.length) {
			return { currIndex, detail: {}, list: [] };
		}

		try {
		/**
		 * hour, minute: Number
		 * price: Number
		 * end_time, begin_time: HH:mm
		 * begin, end: dayjs
		 */
		occupy_list.forEach((i, index) => {
			i.end_time = dayjs().hour(i.hour).minute(i.minute).format('HH:mm');
			if (index === 0) {
				i.begin_time = '00:00';
			} else {
				let last_end_time = occupy_list[index - 1];
				i.begin_time = dayjs()
				.hour(last_end_time.hour)
				.minute(last_end_time.minute + 1)
				.format('HH:mm');
			}

			i.begin = dayjs(`${timeLabel} ${i.begin_time}:00 000`);
			i.end = dayjs(`${timeLabel} ${i.end_time}:59 999`);


			if (curr.isBetween(i.begin, i.end, null, '[]')) {
				currIndex = index;
			}
		});
		} catch (error) {
			console.log('getCarChargeOccupyModel error:', error);
		} finally {
			return { currIndex, detail: model, list: occupy_list };
		}
	},
	// 两轮充 按时/按量
	getPlugSerChargeModel(model) {
		let max = 0,
			min = 9999999;
		let currIndex = 0;
		let curr = dayjs().year(2000).month(0).date(1);
		if (!model || !model.hasOwnProperty('list') || model.mode !== Const.CHARGE.TYPE.TIME_SERVICE) {
			return { currIndex, detail: {}, list: [], max, min };
		}
		try {
			/**
			 * hour, minute: Number
			 * energy_price, service_price: Number
			 * total: Number
			 * end_time, begin_time: HH:mm
			 * begin, end: dayjs
			 */
			model.list.forEach((i, index) => {
				i.end_time = dayjs().hour(i.hour).minute(i.minute).format('HH:mm');
				if (index === 0) {
					i.begin_time = '00:00';
				} else {
					let last_end_time = model.list[index - 1];
					i.begin_time = dayjs()
						.hour(last_end_time.hour)
						.minute(last_end_time.minute + 1)
						.format('HH:mm');
				}

				i.begin = dayjs(`2000-01-01 ${i.begin_time}:00 000`);
				i.end = dayjs(`2000-01-01 ${i.end_time}:59 999`);

				i.total = i.energy_price + i.service_price;

				if (i.total > max) {
					max = i.total;
				}
				if (i.total < min) {
					min = i.total;
				}
				// i.order = index + 1;

				// console.log('curr:', curr.format('YYYY-MM-DD HH:mm:ss SSS'), 'begin:', i.begin.format('YYYY-MM-DD HH:mm:ss SSS'), 'end:', i.end.format('YYYY-MM-DD HH:mm:ss SSS'));
				if (curr.isBetween(i.begin, i.end, null, '[]')) {
					currIndex = index;
				}
			});
		} catch (error) {
			console.log('getPlugSerChargeModel error:', error);
		} finally {
			return { currIndex, detail: model, list: model.list, max, min };
		}
	},
	// 两轮充 按功率
	getPlugSerPowerChargeModel(model) {
		if (!model || !model.hasOwnProperty('service_fee_list') || model.mode !== Const.CHARGE.TYPE.TIME_SERVICE) {
			return { detail: {}, service_fee_list: [] };
		}

		try {
			/**
			 * capacity_max: Number
			 * capacity_min: Number
			 * price: Number
			 * time: String
			 * end_power,begin_power Number
			 */
			// 现在对服务费列表不需要进行任何操作
			model.service_fee_list.forEach((i, index) => {
				i.end_power = i.power;
				if (index === 0) {
					i.begin_power = 0;
				} else {
					let last_end_power = model.service_fee_list[index - 1];
					i.begin_power = last_end_power.power;
				}
			});
		} catch (error) {
			console.log('getPlugSerPowerChargeModel error:', error);
		} finally {
			return { detail: model, service_fee_list: model.service_fee_list };
		}
	},

	/**
	 * 获取某个时间对应的计费模板档位下标
	 */
	getIndexByChargeModelList(list, time) {
		try {
			let currIndex = -1;

			if (!time || !list.length) {
				return currIndex
			}

			let curr = dayjs(time).year(2000).month(0).date(1);

			let timeLabel = '2000-01-01';

			list.forEach((i, index) => {
				i.begin = dayjs(`${timeLabel} ${i.begin_time}:00 000`);
				i.end = dayjs(`${timeLabel} ${i.end_time}:59 999`);

				if (curr.isBetween(i.begin, i.end, null, '[]')) {
					currIndex = index;
				}
			})

			return currIndex;
		} catch (err) {
			console.log("getIndexByChargeModelList err:", err);
			return -1;
		}
	},

	/**
	 * 实付金额 计费详情  差值处理
	 * list   前端算出来的列表
	 * diff   金额差值：  设备金额 - 前端算出来的金额  
	 * key    需要操作的字段名字
	 */
	disposeChargeDetailsDifference(list = [], diff = 0, key = '', divisor_key = '') {
		try {
			if (!list.length) return [];

			// !1 false 
			// !-1 false 
			// !0 true
			if (!key || !diff || !divisor_key) return list;

			/**
			 * 
			 * 每一项的电费和服务费  分别差值为 ±0.01
			 * 有差值的情况下  每项的电费或者服务费 加/减 的金额为 0.01
			 * 顺序为  从第一项开始到最后一项
			 * 处理一遍后  还有差值   再从头来一次
			 * 直到没有差值
			 * 注： 减的情况  金额小于0.01 的不参与计算
			 * 直到把差值  加/减 完
			 */
			let surplus = Math.abs(diff); // 剩余差值  取绝对值
			let min_price = 1 / 100;  // 0.01

			/**
			 * 判断是加还是减
			 * 加 ---> 0.01 + 0.01
			 * 减 ---> 0.01 + -0.01
			 * 
			 * sign  （数）正负号
			 * 
			 * 金额差值 > 0  前端算出来的金额 需要加
			 * 金额差值 < 0  前端算出来的金额 需要减
			 */
			let sign = 1;
			if (diff < 0) {
				sign = -1;
			}

			// 有差值  先进行一轮加/减操作
			for (const item of list) {
				// 差值为0
				if (surplus <= 0) break;

				// 有剩余差值 进行下面操作
				/**
				 * 该项金额小于等于0.01
				 * 加0.01 金额变化明显  所以放到其他项加
				 * 减0.01 防止金额变成0  放到其他项减
				 */
				let price = min_price * item[divisor_key];

				// 当金额为0  不可以减了
				if (item[key] === 0 && sign <= 0) continue;

				// 该项金额大于0.01
				item[key] = item[key] + (price * sign);
				surplus -= price;
			}

			// 差值还有剩余  再进行一轮加/减操作
			if (surplus > 0) {
				list = this.disposeChargeDetailsDifference(list, (surplus * sign), key, divisor_key);
			}

			// console.log("getChargeDetails  list:", list);
			return list;
		} catch (err) {
			console.log("getChargeDetails  err:", err);
			return list;
		}
	},
	/**
	 * money  金额
	 * divisor  需要乘/除的因子
	 * flag  true  截断    false  四舍五入
	 * false 如 4590 ===> 4600
	 */
	moneyIntercept(money = 0, divisor = 100, flag = false) {
		let result = money;
		if (flag) {
			// 截断
			// 例： 4590 ===> 0.45
			// Math.trunc() 的运行方式很简单，它只是截断其右边的点和数字。不管参数是正数还是负数。
			result = Math.trunc(result / (divisor / 100));
			result = result / 100;

			// 例： 0.45 ===> 4500
			result = this.countFilter(result, divisor, 0, true);
		} else {
			// 四舍五入
			// 例： 4590 ===> 0.46
			result = this.countFilter(result, divisor, 2);

			// 例： 0.46 ===> 4600
			result = this.countFilter(result, divisor, 0, true);
		}

		return result;
	},

	/** 计算预约充电订单金额 */
	calcBookingOrderMoney(order = {}) {
		try {
			if (this.isEmptyObj(order)) return {};

			const { 
				charge: order_charge = 0,   // 订单花费
				booking_order = {},         // 预约订单信息
				detail: order_detail = {},  // 订单的一些信息
			} = order;

			if (this.isEmptyObj(booking_order)) return {};
			if (order_detail.flag_booking !== Const.ORDER.FLAG_BOOKING.PRECONTRACT) return {};
			
			// console.log("calcBookingOrderMoney  booking_order:", booking_order);
			const {
				charging_price: booking_charging_price = 0,          // 充电预付
				charge_money_consumed: booking_charge_money_consumed = 0,   // 充电花费
				occupy_price: booking_occupy_price = 0,          // 占位预付
				occupy_money_consumed: booking_occupy_money_consumed = 0,   // 占位花费
			} = booking_order;  
			/**
			 * 预约订单 后端计算charge步骤：
			 * 结合用户规则
			 * 电费 energy_money * 比例 car_energy_fee_rate  四舍五入
			 * 服务费 service_fee_money * 比例 car_service_fee_rate  四舍五入
			 * 最后  电费 + 服务费 + 占位费  === 实际收费(charge)
			 * 电费 + 服务费 = 实际收费 - 占位费
			 */

			// 计算花费金额（电费和服务费）
			let calc_charge_money_consumed = (order_charge >= booking_occupy_money_consumed) ? (order_charge - booking_occupy_money_consumed) : 0;

			// 计算充电结束后退款金额
			let calc_charge_refund_money = (booking_charging_price >= calc_charge_money_consumed) ? (booking_charging_price - calc_charge_money_consumed) : 0;

			// 计算占位结束后退款金额
			let calc_occupy_refund_money = (booking_occupy_price >= booking_occupy_money_consumed) ? (booking_occupy_price - booking_occupy_money_consumed) : 0;

			let result = {};
			result = {
				...booking_order,
				calc_charge_money_consumed,
				calc_charge_refund_money,
				calc_occupy_refund_money,
			}
			
			// console.log("calcBookingOrderMoney  result:", result);
			return result;
		} catch (err) {
			console.log("calcBookingOrderMoney  err:", err)
			return {};
		}
	},

	/** 结合用户规则计算电费和服务费 */
	calcEnergyAndServiceFeeMoney(order = {}, type = 'car') {
		try {
			if (this.isEmptyObj(order)) return {};

			const { 
				detail: order_detail = {},  // 订单的一些信息
				extend: order_extend = {},  // 订单存储的一些信息
			} = order;

			if (this.isEmptyObj(order_detail)) return {};

			const { 
				energy_money = 0,        // 设备上报的电费
				service_fee_money = 0,   // 设备上报的服务费
			} = order_detail;

			/**
			 * 订单 后端计算charge步骤：
			 * 结合用户规则
			 * 电费 energy_money * 比例 car_energy_fee_rate  四舍五入
			 * 服务费 service_fee_money * 比例 car_service_fee_rate  四舍五入
			 * 最后  电费 + 服务费 + 占位费  === 实际收费(charge)
			 * 电费 + 服务费 = 实际收费 - 占位费
			 * 
			 * config  car_service_fee_rate,car_energy_fee_rate
			 */

			/**
			 * 例
			 * 用户规则
			 * { "car_service_fee_rate": 80, "car_energy_fee_rate": 70},
			 * 
			 * 订单里面
			 * detail: { energy_money: 56, service_fee_money: 49 },
			 * charge: 78,
			 * 
			 * 结合用户规则
			 * 56 * 0.7 = 39.2;
			 * 49 * 0.8 = 39.2;    四舍五入   // 39
			 * 
			 * 电费：39.2 四舍五入   // 39
			 * 服务费：39.2 四舍五入   // 39
			 * 最后相加
			 * 39 + 39 = 78;
			 * 
			 * 后端：先4舍5入，在相加
			 * 2024-8-13  询问
			 */

			// 电费
			let calc_energy_money = energy_money;
			// 服务费
			let calc_service_fee_money = service_fee_money;
			// 金额  显示在页面需要除的因子
			let calc_divisor = 100;

			let result = {
				calc_energy_money,
				calc_service_fee_money,
				calc_divisor,
			};

			// 下单存储的信息
			if (!this.isEmptyObj(order_extend) && order_extend.data) {
				// 结合用户规则计算电费和服务费
				// 获取用户规则
				let data = JSON.parse(order_extend.data) || {};
				let user_rule = data.user_rule ? JSON.parse(data.user_rule) : {};

				// 设置的用户规则是折扣
				if (!this.isEmptyObj(user_rule) && user_rule.mode === Const.USER_RULE.MODE.DISCOUNT) {
					let config = user_rule.config ? JSON.parse(user_rule.config) : {};

					let service_fee_rate = 100;
					let energy_fee_rate = 100;

					switch (type) {
						case 'car':
							service_fee_rate = config.car_service_fee_rate >= 0 ? config.car_service_fee_rate : 100;
							energy_fee_rate = config.car_energy_fee_rate >= 0 ? config.car_energy_fee_rate : 100;
							break;
						case 'plug':
							service_fee_rate = config.service_fee_rate >= 0 ? config.service_fee_rate : 100;
							energy_fee_rate = config.energy_fee_rate >= 0 ? config.energy_fee_rate : 100;
							break;
					}

					// 计算电费 服务费  结合用户规则
					result.calc_energy_money = calc_energy_money * energy_fee_rate;
					result.calc_service_fee_money = calc_service_fee_money * service_fee_rate;
					result.calc_divisor *= 100;
				}
			}

			return result;
		} catch (err) {
			console.log("calcEnergyAndServiceFeeMoney  err:", err);
			return {};
		}
	},
	/* ======== 订单管理 ========== */


	/* ======== 广告管理 ========== */
	adverIdFilter(val, to = 'text') {
		const database = process.env.VUE_APP_DATABASE || 'production'
		const MAP = database === 'production' ?  Const.ADVERTISING.AD_ID_MAP : Const.ADVERTISING.AD_ID_MAP_DEV;
		const ITEM = MAP[val + ''] || {};
		return ITEM[to] || '-';
	},
	/* ======== 广告管理 ========== */

	/* ======== 有序充电管理 ========== */
	orderlyChargingStrategyTypeFilter(val, to = 'text') {
		const MAP = Const.ORDERLY_CHARGING.STRATEGY.TYPE_MAP;
		const ITEM = MAP[val + ''] || {};
		return ITEM[to] || '-';
	},
	/* ======== 有序充电管理 ========== */
	
	/* ======== 运营商定制 ========== */
	/**
	 * 
	 * 检验form表单里面的数据是否有改动  返回true  有改动    返回false 没有
	 */
	checkFormChange(form, checkForm) {
		try {
			if (this.isEmptyObj(form) || this.isEmptyObj(checkForm)) {
				return false;
			}

			// 有改动
			let keys = Object.keys(form);
			if (!keys.length) {
				return false;
			}

			for (var i = 0; i < keys.length; i++) {
				let key = keys[i];
				if (isObject(form[key])) {
					if (this.checkFormChange(form[key], checkForm[key])) {
						return true;
					}
				} else if (form[key] !== checkForm[key]) {
					return true;
				}
			}

			return false;
		} catch (err) {
			return false;
		}
	},
	/* ======== 运营商定制 ========== */

	/* ======== 计费模板 ========== */
	/**
	 * 计费模板过滤
	 */
	chargeModelFilter(model = {}) {
		try {
			model.list = model.list || [];
			return model;
		} catch (err) {
			return model
		}
	},
	/* ======== 计费模板 ========== */

	/* ======== 片区管理 ========== */
	/**
	 * 获取片区对应的运营产品类型
	 */
	getChargeConfigKeys(chargeConfig = {}) {
		try {
			if (this.isEmptyObj(chargeConfig)) {
				return [];
			}
			
			let list = [];
			if (!this.isEmptyObj(chargeConfig.plug)) {
				list.push('plug')
			}
			if (!this.isEmptyObj(chargeConfig.car)) {
				list.push('car')
			}
			if (!this.isEmptyObj(chargeConfig.car_ykc)) {
				list.push('car_ykc')
			}
			if (!this.isEmptyObj(chargeConfig.tank)) {
				list.push('tank')
			}
			if (!this.isEmptyObj(chargeConfig.cabinet)) {
				list.push('cabinet')
			}

			console.log("getChargeConfigKeys  list:", list);

			return list;
		} catch (err) {
			console.log("getChargeConfigKeys ~ err:", err);
			return [];
		}
	},

	// 配置支持的运营产品类型   结合片区对应的运营产品类型  做判断
	handleCheckChargeKeys(key = [], chargeKeys = []) {
		// key转大写
		key = key.toUpperCase();
		let config_charge_keys = Const.CHARGE_KEY[key] || [];
		console.log("handleCheckChargeKeys ~ config_charge_keys:", config_charge_keys)
		// 配置的运营产品类型  包含  片区对应的运营产品类型  则返回true
		return config_charge_keys.some((j) => chargeKeys.includes(j));
	},
	/* ======== 片区管理 ========== */

	/** 解析 action/list-by-order-id 单条记录的 data（JSON 字符串或对象） */
	parseOrderActionItemData(raw) {
		if (!raw) {
			return {};
		}
		if (typeof raw === 'object') {
			return raw;
		}
		try {
			return JSON.parse(raw);
		} catch (err) {
			return {};
		}
	},
	isValidOrderActionTime(time) {
		if (time === undefined || time === null || time === '') {
			return false;
		}
		const num = Number(time);
		return isNaN(num) || num > 0;
	},
	/** 从 action/list-by-order-id 列表提取待退款时间轴字段 */
	extractSettleTimelineFromActionList(list) {
		if (!Array.isArray(list) || !list.length) {
			return {};
		}
		const ENTER_TYPE = Const.CHARGING.ORDER_ACTION_TYPE.WAITING_REFUND_ENTER;
		const SETTLE_TYPE = Const.CHARGING.ORDER_ACTION_TYPE.WAITING_REFUND_SETTLE;
		const TIMEOUT_EXIT_TYPE = Const.CHARGING.ORDER_ACTION_TYPE.WAITING_REFUND_TIMEOUT_EXIT;
		let waitingRefundEnterTime = null;
		let clearingSettleSource = null;
		let waitingRefundTimeoutExitTime = null;
		let hasWaitingRefundTimeoutExit = false;

		for (const item of list) {
			const type = Number(item && item.type);
			const data = this.parseOrderActionItemData(item && item.data);

			if (type === ENTER_TYPE) {
				const enterTime = data.waiting_refund_enter_time;
				if (waitingRefundEnterTime == null && this.isValidOrderActionTime(enterTime)) {
					waitingRefundEnterTime = enterTime;
				}
				continue;
			}

			if (type === TIMEOUT_EXIT_TYPE) {
				hasWaitingRefundTimeoutExit = true;
				clearingSettleSource = Const.CHARGING.CLEARING_SETTLE_SOURCE.TIMEOUT_FULL_CHARGE;
				const exitTime = data.waiting_refund_timeout_exit_time;
				if (this.isValidOrderActionTime(exitTime)) {
					waitingRefundTimeoutExitTime = exitTime;
				}
				continue;
			}

			if (type === SETTLE_TYPE) {
				const source = data.clearing_settle_source;
				if (!hasWaitingRefundTimeoutExit && source !== undefined && source !== null && source !== '') {
					clearingSettleSource = source;
				}
				continue;
			}

			const time = data.waiting_refund_enter_time;
			if (waitingRefundEnterTime == null && this.isValidOrderActionTime(time)) {
				waitingRefundEnterTime = time;
			}
			const source = data.clearing_settle_source;
			if (!hasWaitingRefundTimeoutExit && source !== undefined && source !== null && source !== '') {
				clearingSettleSource = source;
			}
		}

		const result = {};
		if (waitingRefundEnterTime != null) {
			result.waiting_refund_enter_time = waitingRefundEnterTime;
		}
		if (clearingSettleSource != null) {
			result.clearing_settle_source = clearingSettleSource;
		}
		if (waitingRefundTimeoutExitTime != null) {
			result.waiting_refund_timeout_exit_time = waitingRefundTimeoutExitTime;
		}
		if (hasWaitingRefundTimeoutExit) {
			result.has_waiting_refund_timeout_exit = true;
		}
		return result;
	},
	/** 解析 clearing_settle_source（数字枚举） */
	normalizeClearingSettleSource(raw) {
		if (raw === undefined || raw === null || raw === '') {
			return null;
		}
		const num = Number(raw);
		return isNaN(num) ? null : num;
	},
	/** 结算来源展示文案 */
	clearingSettleSourceText(source) {
		const normalized = typeof source === 'number' ? source : this.normalizeClearingSettleSource(source);
		if (normalized === null) {
			return '';
		}
		const item = Const.CHARGING.CLEARING_SETTLE_SOURCE_MAP[String(normalized)];
		return item ? item.text : '';
	},
};

// console.log('Util.device(PLUG);', Util.device('PLUG'));
// console.log('Util.device(PILE);', Util.device('PILE'));
// console.log('Util.device(TANK);', Util.device('TANK'));
// console.log('Util.device(CABINET);', Util.device('CABINET'));

export default Util;
